"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _commonReact = require("@devsta/common-react");

var _Controls = _interopRequireDefault(require("./Controls"));

var _Timeline = _interopRequireDefault(require("./Timeline"));

var _Video = _interopRequireDefault(require("./Video"));

var _AssetTranscodeListener = _interopRequireDefault(require("./AssetTranscodeListener"));

var _PlayerContext = _interopRequireDefault(require("../contexts/PlayerContext"));

var _utils = require("../utils");

var _keyShortcuts = require("../constants/keyShortcuts");

var _playerContext = _interopRequireDefault(require("../selectors/playerContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Advanced = /*#__PURE__*/function (_Component) {
  _inherits(Advanced, _Component);

  var _super = _createSuper(Advanced);

  function Advanced(props) {
    var _this;

    _classCallCheck(this, Advanced);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "replaceTempClipId", function () {
      var videoClips = _this.props.videoClips;
      var _this$state = _this.state,
          currentClip = _this$state.currentClip,
          playableClips = _this$state.playableClips,
          currentTime = _this$state.currentTime;

      if (!currentClip || !currentClip.clipId || !currentClip.clipId.includes('clip-')) {
        return;
      }

      var selectedClip = videoClips.find(function (pc) {
        return pc.assetId === currentClip.assetId;
      });

      if (!selectedClip || selectedClip.clipId.includes('clip-')) {
        return;
      }

      var playableClipIndex = playableClips.findIndex(function (_ref) {
        var clipId = _ref.clipId;
        return clipId === currentClip.clipId;
      });

      if (playableClipIndex === -1) {
        return;
      }

      var updatedPlayableClip = _objectSpread(_objectSpread({}, playableClips[playableClipIndex]), {}, {
        clipId: selectedClip.clipId
      });

      _this.setState({
        currentClip: _objectSpread(_objectSpread({}, currentClip), {}, {
          clipId: selectedClip.clipId
        }),
        playableClips: [].concat(_toConsumableArray(playableClips.slice(0, playableClipIndex)), [updatedPlayableClip], _toConsumableArray(playableClips.slice(playableClipIndex + 1)))
      }, function () {
        _this.handleOverrideCurrentTime(currentTime);

        _this.setState({
          buffering: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "stateSelector", function () {
      return _this.state;
    });

    _defineProperty(_assertThisInitialized(_this), "onVideoReady", function () {
      _this.setState({
        buffering: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLoop", function () {
      _this.setState(function (_ref2) {
        var loop = _ref2.loop;
        return {
          loop: !loop
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeZoomSeconds", function (zoomSeconds) {
      var timelineZoomSeconds = _this.state.timelineZoomSeconds;

      if (zoomSeconds === timelineZoomSeconds) {
        return;
      }

      _this.setState({
        timelineZoomSeconds: zoomSeconds
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateClipLayers", function (bottomClips, topClips) {
      var pause = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _this$props = _this.props,
          onUpdateVideoClips = _this$props.onUpdateVideoClips,
          assets = _this$props.assets;
      var playableClips = _this.state.playableClips;

      if (pause) {
        _this.onPause();
      }

      var newPlayableClips = (0, _utils.createPlayableClipArray)(bottomClips, topClips, assets);

      _this.setState((0, _utils.handleUpdatedPlayableClips)(playableClips, newPlayableClips));

      onUpdateVideoClips([].concat(_toConsumableArray(bottomClips), _toConsumableArray(topClips)));
    });

    _defineProperty(_assertThisInitialized(_this), "setVideoRef", function (el) {
      if (!el) {
        return;
      }

      if (_this._videoRef) {
        _this._videoRef.removeEventListener('timeupdate', _this.handlePlayerTimeUpdate);
      }

      el.addEventListener('timeupdate', _this.handlePlayerTimeUpdate);
      el.addEventListener('loadeddata', _this.onVideoReady);
      _this._videoRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "onTogglePlayState", function () {
      var playing = _this.state.playing;

      if (playing) {
        return void _this.onPause();
      }

      _this.onPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      var isCommentModalOpen = _this.props.isCommentModalOpen;

      if (isCommentModalOpen) {
        return;
      }

      (0, _utils.handleKeyShortcuts)(_defineProperty({}, _keyShortcuts.SPACE, _this.onTogglePlayState))(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var playableClips = _this.state.playableClips;
      var _this$state2 = _this.state,
          currentTime = _this$state2.currentTime,
          totalDuration = _this$state2.totalDuration;
      var shouldRestart = currentTime === totalDuration;

      _this.setState(function (_ref3) {
        var currentClip = _ref3.currentClip,
            elapsedDuration = _ref3.elapsedDuration;
        return {
          playing: true,
          currentClip: shouldRestart ? playableClips[0] : currentClip,
          elapsedDuration: shouldRestart ? 0 : elapsedDuration,
          currentTime: shouldRestart ? 0 : (0, _utils.normaliseTime)(currentTime, totalDuration)
        };
      }, function () {
        var _this$state3 = _this.state,
            currentClip = _this$state3.currentClip,
            manualPlayHandler = _this$state3.manualPlayHandler;
        (0, _utils.updateVideoElement)({
          videoEl: _this._videoRef,
          newTime: shouldRestart && currentClip ? currentClip.clipStartTime : void 0,
          currentClip: currentClip,
          onUpdate: manualPlayHandler.attemptStart,
          forceScroll: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var playing = _this.state.playing;

      if (!playing) {
        return;
      }

      _this.setState({
        playing: false
      }, function () {
        var currentClip = _this.state.currentClip;
        (0, _utils.updateVideoElement)({
          videoEl: _this._videoRef,
          currentClip: currentClip,
          videoAction: 'pause',
          newPlaybackRate: 1
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChapterBack", function () {
      var _this2;

      var _this$state4 = _this.state,
          currentTime = _this$state4.currentTime,
          currentClip = _this$state4.currentClip,
          playableClips = _this$state4.playableClips;

      if (currentTime === 0 || !currentClip) {
        return;
      } // $FlowFixMe There's a falsy check for currentClip above but Flow ignores when destructuring


      var setStateArgs = _utils.chapters.previous(_objectSpread(_objectSpread({}, _this.state), {}, {
        playableClips: playableClips,
        onPause: _this.onPause,
        videoEl: _this._videoRef
      }));

      (_this2 = _this).setState.apply(_this2, _toConsumableArray(setStateArgs));
    });

    _defineProperty(_assertThisInitialized(_this), "onChapterForward", function () {
      var _this3;

      var _this$state5 = _this.state,
          totalDuration = _this$state5.totalDuration,
          currentTime = _this$state5.currentTime,
          currentClip = _this$state5.currentClip,
          playableClips = _this$state5.playableClips;

      if (currentTime === totalDuration || !currentClip) {
        return;
      } // $FlowFixMe There's a falsy check for currentClip above but Flow ignores when destructuring


      var setStateArgs = _utils.chapters.next(_objectSpread(_objectSpread({}, _this.state), {}, {
        playableClips: playableClips,
        onPause: _this.onPause,
        videoEl: _this._videoRef
      }));

      (_this3 = _this).setState.apply(_this3, _toConsumableArray(setStateArgs));
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlayerTimeUpdate", function () {
      var _this4;

      var _this$state6 = _this.state,
          playing = _this$state6.playing,
          currentClip = _this$state6.currentClip,
          manualPlayHandler = _this$state6.manualPlayHandler,
          playableClips = _this$state6.playableClips;

      if (!playing || !_this._videoRef || !currentClip) {
        return;
      } // $FlowFixMe There's a falsy check for currentClip above but Flow ignores when destructuring


      var setStateArgs = (0, _utils.videoTimeUpdate)(_objectSpread(_objectSpread({}, _this.state), {}, {
        playableClips: playableClips,
        onPause: _this.onPause,
        videoEl: _this._videoRef,
        handleManualPlay: manualPlayHandler.attemptStart
      }));

      if (!setStateArgs) {
        return;
      }

      (_this4 = _this).setState.apply(_this4, _toConsumableArray(setStateArgs));
    });

    _defineProperty(_assertThisInitialized(_this), "handleOverrideCurrentTime", function (time) {
      var _this5;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          skipPause = _ref4.skipPause;

      var _this$state7 = _this.state,
          currentClip = _this$state7.currentClip,
          playableClips = _this$state7.playableClips;

      if (!currentClip) {
        return;
      } // $FlowFixMe There's a falsy check for currentClip above but Flow ignores when destructuring


      var setStateArgs = (0, _utils.manualVideoTimeUpdate)(_objectSpread(_objectSpread({}, _this.state), {}, {
        playableClips: playableClips,
        onPause: _this.onPause,
        videoEl: _this._videoRef,
        skipPause: skipPause,
        time: time
      }));

      (_this5 = _this).setState.apply(_this5, _toConsumableArray(setStateArgs));
    });

    var _assets = props.assets;

    var _topClips = props.videoClips.filter(function (clip) {
      return clip.layerIndex === 0;
    });

    var _bottomClips = props.videoClips.filter(function (clip) {
      return clip.layerIndex === 1;
    });

    var initialPlayableClips = (0, _utils.createPlayableClipArray)(_topClips, _bottomClips, _assets);
    _this.state = {
      playing: false,
      currentTime: 0,
      playableClips: initialPlayableClips,
      totalDuration: (0, _utils.getTotalClipsDuration)(initialPlayableClips),
      currentClip: initialPlayableClips[0],
      elapsedDuration: 0,
      timelineZoomSeconds: 1,
      buffering: Boolean(initialPlayableClips.length),
      loop: false,
      manualPlayHandler: new _utils.ManualPlayHandler({
        stateSelector: _this.stateSelector,
        handleOverrideCurrentTime: _this.handleOverrideCurrentTime
      })
    };
    return _this;
  }

  _createClass(Advanced, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keypress', this.handleKeyPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keypress', this.handleKeyPress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          assets = _this$props2.assets,
          videoClips = _this$props2.videoClips;
      var prevAssets = prevProps.assets;
      this.replaceTempClipId();

      if ((0, _lodash.default)(assets, prevAssets)) {
        return;
      }

      var topClips = videoClips.filter(function (clip) {
        return clip.layerIndex === 0;
      });
      var bottomClips = videoClips.filter(function (clip) {
        return clip.layerIndex === 1;
      });
      this.onUpdateClipLayers(bottomClips, topClips, false);
    } // Replaces clips with tempId in memory after they are saved to the DB

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          canUpdateVideo = _this$props3.canUpdateVideo,
          videoClips = _this$props3.videoClips,
          selectedDrawerAssets = _this$props3.selectedDrawerAssets;
      var _this$state8 = this.state,
          currentClip = _this$state8.currentClip,
          timelineZoomSeconds = _this$state8.timelineZoomSeconds,
          buffering = _this$state8.buffering,
          loop = _this$state8.loop,
          playing = _this$state8.playing,
          currentTime = _this$state8.currentTime,
          totalDuration = _this$state8.totalDuration,
          playableClips = _this$state8.playableClips;

      var _ref5 = currentClip || {},
          assetId = _ref5.assetId,
          _ref5$clipId = _ref5.clipId,
          clipId = _ref5$clipId === void 0 ? '' : _ref5$clipId;

      var isTempClipId = clipId.includes('clip-');
      return /*#__PURE__*/_react.default.createElement(_PlayerContext.default.Provider, {
        value: (0, _playerContext.default)(this.state)
      }, /*#__PURE__*/_react.default.createElement(_AssetTranscodeListener.default, null), /*#__PURE__*/_react.default.createElement(_Video.default, {
        currentClip: currentClip,
        setVideoRef: this.setVideoRef,
        buffering: buffering,
        loop: loop,
        toggleLoop: this.toggleLoop,
        assetId: assetId
      }, !isTempClipId ? /*#__PURE__*/_react.default.createElement(_commonReact.CommentsOverlay, {
        selectedClip: currentClip,
        selector: ".controls__comments",
        isPlaying: playing,
        time: currentTime,
        totalDuration: totalDuration,
        pauseTime: this.onPause,
        setCustomTime: this.handleOverrideCurrentTime
      }) : null), /*#__PURE__*/_react.default.createElement(_Timeline.default, {
        timelineZoomSeconds: timelineZoomSeconds,
        onOverrideCurrentTime: playableClips.length ? this.handleOverrideCurrentTime : void 0,
        initialClips: videoClips,
        canUpdateVideo: canUpdateVideo,
        onUpdateClipLayers: this.onUpdateClipLayers,
        selectedDrawerAssets: selectedDrawerAssets
      }), /*#__PURE__*/_react.default.createElement(_Controls.default, {
        onChangeZoomSeconds: this.onChangeZoomSeconds,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onChapterBack: this.onChapterBack,
        onChapterForward: this.onChapterForward,
        hasClips: Boolean(playableClips.length)
      }));
    }
  }]);

  return Advanced;
}(_react.Component);

var _default = (0, _commonReact.withAssetsSelector)(Advanced);

exports.default = _default;